export class Proyecto {
	constructor(
		public uuid: string,
		public nombre: string,
		public spike: number,
	) {}
}